module.exports = __webpack_public_path__ + "static/img/feature-icon5@3x.9c57c888.png";